import ExpandMoreRounded from "@mui/icons-material/ExpandMoreRounded";
// ----------------------------------------------------------------------

export default function Select() {
  return {
    MuiSelect: {
      defaultProps: {
        IconComponent: ExpandMoreRounded,
      },

      styleOverrides: {
        root: {},
      },
    },
  };
}
